import { render, staticRenderFns } from "./sayfalama.vue?vue&type=template&id=b4326ab6&scoped=true&"
import script from "./sayfalama.vue?vue&type=script&lang=js&"
export * from "./sayfalama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4326ab6",
  null
  
)

export default component.exports